/**
 ********************* NEEDS DOCUMENTATION *********************
 */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { thumbsUpSelector } from "../redux";
import { RETIRE_AGE, CONTRIBUTION, inflation, LIFE_EXP, strategyOptions, } from "../constants";
const binomial_no_coeff = (x, y, n) => {
    if (n === 0) {
        return 1;
    }
    let total = 0;
    for (let i = 0; i <= n; ++i) {
        total += Math.pow(x, i) * Math.pow(y, n - i);
    }
    return total;
};
export const useThumbsup = () => {
    const thumbsUpValues = useSelector(thumbsUpSelector);
    const { expense_home, r_after, r_before, retireYears, openingBalance, currentAge, contributionVal, lifeExpVal, earnYears, r_after_max, r_before_max, } = thumbsUpValues;
    const [{ values, loading }, setValues] = useState({
        values: null,
        loading: true,
    });
    const calculateContribution = (maxRetire, maxStrategy) => {
        const retireYearsVal = maxRetire
            ? lifeExpVal - RETIRE_AGE.MAX - 1
            : retireYears;
        const earnYearsVal = maxRetire ? RETIRE_AGE.MAX - currentAge : earnYears;
        const r_b = maxStrategy ? r_before_max : r_before;
        const r_a = maxStrategy ? r_after_max : r_after;
        const r_n_b = r_b ** earnYearsVal;
        const r_n_a = r_a ** retireYearsVal;
        const returnVal = {
            contribution: CONTRIBUTION.MAX + 0.00001,
        };
        const contri = ((expense_home *
            // inflation *
            binomial_no_coeff(r_a, inflation, retireYearsVal) -
            openingBalance * r_n_b * r_n_a) *
            (r_b - 1)) /
            (r_n_a * r_b * (r_n_b - 1));
        if (contri >= CONTRIBUTION.MAX) {
            const retireMaxContri = !maxRetire
                ? calculateRetireAge(true).retireAge
                : RETIRE_AGE.MAX;
            returnVal.contribution = CONTRIBUTION.MAX;
            if (retireMaxContri >= RETIRE_AGE.MAX) {
                const stratMaxRetire = !maxStrategy
                    ? calculateStrategy(true, true).strategy
                    : 3;
                returnVal.retireAge = RETIRE_AGE.MAX;
                returnVal.strategy = stratMaxRetire;
            }
            else {
                returnVal.retireAge = retireMaxContri;
            }
        }
        else {
            returnVal.contribution = contri + 0.00001;
        }
        return returnVal;
    };
    const calculateRetireAge = (maxContri, maxStrategy) => {
        const contri = maxContri ? CONTRIBUTION.MAX : contributionVal;
        const r_b = maxStrategy ? r_before_max : r_before;
        const r_a = maxStrategy ? r_after_max : r_after;
        const returnVal = {
            retireAge: RETIRE_AGE.MAX,
        };
        for (let i = currentAge + 1; i < LIFE_EXP.MAX; ++i) {
            const assets = (contri * r_b * (r_b ** (i - currentAge) - 1)) / (r_b - 1) +
                openingBalance * r_b ** (i - currentAge);
            const LHS = assets * r_a ** (lifeExpVal - i);
            const RHS = expense_home *
                // inflation *
                r_a *
                binomial_no_coeff(inflation, r_a, lifeExpVal - i - 1);
            if (LHS > RHS) {
                returnVal.retireAge = i;
                break;
            }
        }
        if (returnVal.retireAge >= RETIRE_AGE.MAX) {
            const contriMaxRetire = !maxContri
                ? calculateContribution(true, false).contribution
                : CONTRIBUTION.MAX;
            returnVal.retireAge = RETIRE_AGE.MAX;
            if (contriMaxRetire >= CONTRIBUTION.MAX) {
                const stratMaxContri = !maxStrategy
                    ? calculateStrategy(true, true).strategy
                    : 3;
                returnVal.contribution = CONTRIBUTION.MAX;
                returnVal.strategy = stratMaxContri;
            }
            else {
                returnVal.contribution = contriMaxRetire;
            }
        }
        return returnVal;
    };
    const calculateStrategy = (maxContri, maxRetire) => {
        const contri = maxContri ? CONTRIBUTION.MAX : contributionVal;
        const retireYearsVal = maxRetire
            ? lifeExpVal - RETIRE_AGE.MAX - 1
            : retireYears;
        const returnVal = { strategy: 3 }; // 3 -> Growth
        for (let i = 1; i <= 3; ++i) {
            const return_rate1 = 1 + +strategyOptions[i].value;
            const return_rate2 = 1 + +strategyOptions[i - 1].value;
            const assets = contri *
                return_rate1 *
                ((return_rate1 ** earnYears - 1) / (return_rate1 - 1)) +
                openingBalance * return_rate1 ** earnYears;
            const LHS = assets * return_rate2 ** retireYearsVal;
            const RHS = expense_home *
                // inflation *
                return_rate2 *
                binomial_no_coeff(inflation, return_rate2, retireYearsVal);
            if (LHS >= RHS) {
                returnVal.strategy = i;
                break;
            }
        }
        if (returnVal.strategy >= 3) {
            const contriMaxStrat = !maxContri
                ? calculateContribution(false, true).contribution
                : CONTRIBUTION.MAX;
            returnVal.strategy = 3;
            if (contriMaxStrat >= CONTRIBUTION.MAX) {
                const retireMaxContri = !maxRetire
                    ? calculateRetireAge(true, true).retireAge
                    : RETIRE_AGE.MAX;
                returnVal.contribution = CONTRIBUTION.MAX;
                returnVal.retireAge = retireMaxContri;
            }
            else {
                returnVal.contribution = contriMaxStrat;
            }
        }
        return returnVal;
    };
    // const isFocused = useIsFocused();
    useEffect(() => {
        setValues((prev) => ({ ...prev, loading: true }));
        const updatedValues = { ...values };
        const updatedContibution = {
            ...updatedValues.contribution,
            ...calculateContribution(),
        };
        const updatedRetireAge = {
            ...updatedValues.retireAge,
            ...calculateRetireAge(),
        };
        const updatedStrategy = {
            ...updatedValues.strategy,
            ...calculateStrategy(),
        };
        updatedValues.contribution = updatedContibution;
        updatedValues.retireAge = updatedRetireAge;
        updatedValues.strategy = updatedStrategy;
        setValues((prev) => ({ ...prev, values: updatedValues, loading: false }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [thumbsUpValues]);
    return { values, loading };
};
